
export const plans = [
    {group:'Earlier', list:[
      {title:'Add new logo to header', done:true, star:true, category:'Tasks' },
      {title:'Retouch to last pages', done:true, category:'Tasks' },
    ]},
    
    {group:'Today', list:[
      {title:'Review drafts #office', done:false, star:true,  category:'Daily' },
    ]},
      
    {group:'Tomorrow', list:[
      {title:'Create a weekly schedule', done:false, category:'Employees' },
    ]},
  
  ]